import { editedCardFieldsContext } from '@context/edited-card-fields-context';
import { PopoverContext } from '@context/popover-context';
import useNode from '@hooks/use-node';
import { TextArea } from '@ui-lib';
import { useContext, useEffect } from 'react';

import LinkStatusContainer from '../LinkStatusContainer/LinkStatusContainer';

interface CompanyEditPopoverProps {
  field: string;
  onChange: (field: string) => void;
  linked?: boolean;
}

const CompanyEditPopover: React.FC<React.PropsWithChildren<CompanyEditPopoverProps>> = ({
  field,
  onChange,
  linked = false,
}) => {
  const { show } = useContext(PopoverContext);
  const [inputNode, inputRef] = useNode<HTMLTextAreaElement>();
  const { onEditAttribute } = useContext(editedCardFieldsContext);

  useEffect(() => {
    if (show && inputNode) {
      const intersectionObserver = new IntersectionObserver((entries, observer) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          setTimeout(() => {
            inputNode.focus();
          }, 150);
          observer.unobserve(entry.target);
        }
      });

      intersectionObserver.observe(inputNode);
    }
  }, [show, inputNode]);

  function handleChange(newValue: string) {
    onEditAttribute('org_name');
    onChange(newValue);
  }

  return (
    <LinkStatusContainer linked={linked}>
      <TextArea
        ref={inputRef}
        value={field}
        onChange={(event) => handleChange(event.currentTarget.value)}
        label="Company name"
      />
    </LinkStatusContainer>
  );
};

export default CompanyEditPopover;
